import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.division.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.division.fields.nombre'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.division.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.division.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
